/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Panel from '@ts-core/components/Panel/Panel';

import { findSubjectsWithParent } from '@ts-core/modules/subjects/utils';

import SubjectsList from './SubjectsList';

const SubjectsPanel = (props) => {
  const {
    subjects,
    loading,
    showSelectedMark,
    onSelectSubject,
    onAddSubject,
    onEditSubject,
    onRemoveSubject,
    onReorderSubject,
    onToggleSubject,
    isSubjectSelected,
    isSubjectOpen,
  } = props;

  const disableDragAndDrop = !onReorderSubject;

  const [selectedSubjectId, setSelectedSubjectId] = useState(null);

  const handleAddSubject = useCallback(() => {
    onAddSubject();
  }, [onAddSubject]);

  const handleOpenMenu = useCallback(
    (subject) => () => {
      setSelectedSubjectId(subject._id);
    },
    []
  );

  const handleCloseMenu = useCallback(() => {
    setSelectedSubjectId();
  }, []);

  const handleOnSortEnd = useCallback(
    (data) => {
      const { newIndex, oldIndex, collection } = data;
      let subject;
      if (collection === 'root') {
        subject = subjects[oldIndex];
      } else {
        const list = findSubjectsWithParent(subjects, collection);
        subject = list[oldIndex];
      }

      onReorderSubject({
        subjectId: subject?._id,
        parentSubjectId: subject.parentSubject,
        from: oldIndex,
        to: newIndex,
      });
    },
    [onReorderSubject, subjects]
  );

  return (
    <Panel>
      <Box display="flex" flexDirection="row">
        <Typography variant="subtitle2">
          <FormattedMessage id="subjects" />
        </Typography>
        <Box flexGrow={1} />
        {onAddSubject && (
          <Button onClick={handleAddSubject} disabled={loading} color="secondary">
            <Typography variant="subtitle2">
              <FormattedMessage id="subjectsPanel.addSubject" />
            </Typography>
          </Button>
        )}
      </Box>
      <SubjectsList
        disableDragAndDrop={disableDragAndDrop}
        loading={loading}
        showSelectedMark={showSelectedMark}
        onSortEnd={handleOnSortEnd}
        distance={10}
        subjects={subjects}
        isSubjectOpen={isSubjectOpen}
        isSubjectSelected={isSubjectSelected}
        onSelectSubject={onSelectSubject}
        openMenuSubjectId={selectedSubjectId}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        onAddSubject={onAddSubject}
        onEditSubject={onEditSubject}
        onRemoveSubject={onRemoveSubject}
        onToggleSubject={onToggleSubject}
      />
    </Panel>
  );
};

SubjectsPanel.propTypes = {
  subjects: PropTypes.array,
  showSelectedMark: PropTypes.bool,
  loading: PropTypes.bool.isRequired,

  onSelectSubject: PropTypes.func.isRequired,
  onEditSubject: PropTypes.func,
  onAddSubject: PropTypes.func,
  onRemoveSubject: PropTypes.func,
  onToggleSubject: PropTypes.func,
  onReorderSubject: PropTypes.func,

  isSubjectSelected: PropTypes.func.isRequired,
  isSubjectOpen: PropTypes.func.isRequired,
};

SubjectsPanel.defaultProps = {
  subjects: [],
  showSelectedMark: false,

  onEditSubject: undefined,
  onAddSubject: undefined,
  onRemoveSubject: undefined,
  onToggleSubject: undefined,
  onReorderSubject: undefined,
};

export default SubjectsPanel;
